module.exports = __webpack_public_path__ + "static/media/circle_30_solid2.788dc452.png";